import React, { useState } from "react";
import { Redirect } from "react-router";

// Custom Components
import Table from "@Components/Table";
import Filter from "@Components/Filter";
import { useTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { NON_WORKING_DAY_WEEKEND_URL, URLS } from "configs/constants";

let model = [
  { id: "day", label: "Day", type: "string" },
  { id: "states", label: "State", type: "string" },
  {
    id: "type_of_attendance_absent_name",
    label: "Type of Attendance (Absent)",
    type: "string",
  },
  {
    id: "type_of_attendance_present_name",
    label: "Type of Attendance (Present)",
    type: "string",
  },
];

const actions = ["edit"];

const filterFields = [
  {
    type: "input",
    label: "Day",
    name: "day",
  },
];

export default function WeekendNonWorkingDay() {
  const { t } = useTranslation();
  const [filterValues, setFilterValues] = useState({});
  const [hariTerabai, setHariTerabai] = useState(false);
  const [weekend, setWeekend] = useState(true);
  const [holiday, setHoliday] = useState(false);
  const [tabValue, setTabValue] = useState("weekend");

  const filterInitialValues = {
    year: "",
  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const handleChange = (event, newValue) => {
    let type = newValue;
    if (type === "holiday") {
      setWeekend(false);
      setHoliday(true);
      setTabValue(type);
    } else if (type === "hari_terabai") {
      setWeekend(false);
      setHariTerabai(true);
      setTabValue(type);
    } else {
      console.log(type);
    }
  };

  if (weekend) {
    return (
      <div>
        <div>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab value="holiday" label={t("Public Holiday")} />
              <Tab value="weekend" label={t("Weekend")} />
              <Tab value="hari_terabai" label="Hari Terabai" />
            </Tabs>
          </Box>
        </div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        />
        <Table
          proxyURL={NON_WORKING_DAY_WEEKEND_URL}
          model={model}
          filterValues={filterValues}
          actions={actions}
          noFilter
        />
      </div>
    );
  } else if (holiday) {
    return <Redirect to={URLS.NON_WORKING_DAY_GLOBAL} />;
  } else if (hariTerabai) {
    return <Redirect to={URLS.NON_WORKING_DAY_HARI_TERABAI} />;
  } else {
    console.log("no where to go.");
  }
}
